<template>
  <div class="container-fluid p-0">
    <div class="row g-0">
      <div class="col-12 col-md-4 col-lg-3 vh-md-100 nav-wrapper">
        <div
          class="
            p-3
            d-flex
            justify-content-between
            align-items-center
            d-md-block
          "
        >
          <h1 class="mb-0">#30DayMapChallenge - 2021</h1>
          <button
            class="btn btn-outline-light btn-lg d-flex px-2 d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navigation"
            aria-controls="navigation"
          >
            <b-icon-list></b-icon-list>
            <span class="visually-hidden">Menu</span>
          </button>
        </div>
        <Navigation class="d-none d-md-block" />
        <div
          class="offcanvas offcanvas-start bg-dark"
          tabindex="-1"
          id="navigation"
          aria-labelledby="navigationLabel"
        >
          <div class="offcanvas-header justify-content-end">
            <button
              type="button"
              class="btn btn-outline-light d-flex p-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <b-icon-x-lg></b-icon-x-lg>
              <span class="visually-hidden">Close</span>
            </button>
          </div>
          <div class="offcanvas-body">
            <MobileNavigation />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8 col-lg-9 map-wrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import MobileNavigation from "./components/MobileNavigation.vue";

export default {
  name: "App",
  components: {
    Navigation,
    MobileNavigation,
  },
};
</script>

<style lang="scss" scoped>
@import "~/node_modules/bootstrap/scss/_functions.scss";
@import "~/node_modules/bootstrap/scss/_variables.scss";
@import "~/node_modules/bootstrap/scss/_mixins.scss";
h1 {
  font-size: 1rem;
}
.nav-wrapper {
  z-index: 2;
}
.map-wrapper {
  position: absolute;
  padding-top: 70px;
  height: 100%;
  z-index: 0;

  @include media-breakpoint-up(md) {
    position: relative;
    height: 100vh;
    padding-top: 0;
  }
}
</style>
